export const AUTH_TOKEN = 'auth_token'
export const USER_DATA = 'user_data'
